import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DhlFormControl } from '../../models/dhl-form-control';
import { UntypedFormGroup } from '@angular/forms';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { AppService } from 'src/app/app.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';

@Component({
    selector: 'app-form-field-toggle-group-v2',
    templateUrl: './form-field-toggle-group-v2.component.html',
    styleUrls: ['./form-field-toggle-group-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldToggleGroupV2Component implements OnInit {

  constructor(private appService: AppService) { }

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;
  disabled: boolean = false;
  checkedBtnValue;

  ngOnInit(): void {
    if(typeof this.frmGroup.get(this.configData.name).value === 'object') {
      this.checkedBtnValue = this.frmGroup.get(this.configData.name).value.value;
    } else if(typeof this.frmGroup.get(this.configData.name).value === 'string') {
      this.checkedBtnValue = this.frmGroup.get(this.configData.name).value;
    }
    this.disabled = this.configData['disabled'];
    let menuPageAccess;
    if(this.configData["menuPageAccess"]) {
      menuPageAccess = this.configData["menuPageAccess"];
    } else {
      menuPageAccess = this.configData["access"];
    }
    if (menuPageAccess) {
      this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(menuPageAccess)
    }
    
    if (this.configData['dynamicVisibility']) {
      if(this.configData['dynamicVisibility'].action == 'hidden') {
        this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
      } 
      else
        if(this.configData['dynamicVisibility'].action == 'disabled') {
          this.disabled = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
        }
    }

    if (this.configData['editAccess']) {
      this.configData['editAccess'].forEach(row => {
        let persona;
        if (row.roleAccess) {
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        if (row.action == 'hidden') {
          this.frmGroup.get(this.configData.name)['hidden'] = !this.checkFieldAccess(persona);
        }
        if (row.action == 'disabled') {
          if (this.checkFieldAccess(persona) == false) {
            this.configData['disabled'] = true;
            this.frmGroup.get(this.configData.name).disable();
          }
        }
      });
    }
  }

  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }

  resetToggleBtnGroupValue() {
    if (!this.frmGroup.get(this.configData.name).value) {
      this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue);
    } else{
      this.frmGroup.get(this.configData.name).setValue(this.frmGroup.get(this.configData.name).value);
    }
    if(typeof this.frmGroup.get(this.configData.name).value === 'object') {
      this.checkedBtnValue = this.frmGroup.get(this.configData.name).value.value;
    } else if(typeof this.frmGroup.get(this.configData.name).value === 'string') {
      this.checkedBtnValue = this.frmGroup.get(this.configData.name).value;
    }
    this.onCommonEventHander('TOGGLE_BUTTON_GROUP', null);
  }

  toggleVisibility(hidden) {
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if(hidden === true)
    this.frmGroup.get(this.configData.name).reset();
    if(this.configData.events && hidden === false)
    this.onCommonEventHander('TOGGLE_BUTTON_GROUP', null);
  }

  onToggleButtonGroupChange(userEvent, option) {
    this.frmGroup.get(this.configData.name).setValue(option);
    this.frmGroup.get(this.configData.name).updateValueAndValidity();
    this.onCommonEventHander('TOGGLE_BUTTON_GROUP', userEvent);
  }

  coldSelectOption(option) {
    this.frmGroup.get(this.configData.name).setValue(option);
    this.checkedBtnValue = option.value;
    if(this.configData.events){
      this.onCommonEventHander('TOGGLE_BUTTON_GROUP', null);
    }
  }

  onCommonEventHander(eventType, userEvent) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.configData['disabled'] === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      if (event) {
        this.sendToSource(event, userEvent);
        if (event && userEvent && this.configData["enableFilterSaveButton"]) {
          this.sendToSource({ "actionType": "ENABLE_SAVE" }, userEvent);
        }
        return
      }
      else if (!event && userEvent && this.configData["enableFilterSaveButton"]) {
        this.sendToSource({ "actionType": "ENABLE_SAVE" }, userEvent);
      }
    }
  }

  sendToSource(event, userEvent) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    eventData['userEvent'] = userEvent;
    
    if (event.actionType === "ENABLE_SAVE" && userEvent && this.configData["enableFilterSaveButton"]) {
      this.appService._commonComponentSubjectFilter.next(eventData);
    }
    else {
      this.appService._commonComponentSubject.next(eventData);
    }
    
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }

  setValueToControl(option) {
    if (option != undefined) {
      this.coldSelectOption(option);
    }
  }
}
